import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";

import { useIsFullscreen } from "src/utils/fullscreen";

function GridToolbarFullscreenButton({ onFullscreenClick }) {
  const isFullscreen = useIsFullscreen();

  if (isFullscreen)
    return (
      <Box position="fixed" top={0} right={0}>
        <IconButton id="icon-button-id" onClick={onFullscreenClick}>
          <FullscreenExitIcon fontSize="large" />
        </IconButton>
      </Box>
    );

  return (
    <Button
      color="primary"
      size="small"
      onClick={onFullscreenClick}
      startIcon={<FullscreenIcon />}
    >
      Fullscreen
    </Button>
  );
}

export default GridToolbarFullscreenButton;
